export default __webpack_public_path__ + "static/services-grass-7e812f7ae068142d48ff81e1187a50d8.webp";